import React from 'react';

import {FormControl, Button, InputGroup, DropdownButton, MenuItem} from 'react-bootstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

class Header extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			filter: null,
			filterCondition: null
		};
	}

	// shouldComponentUpdate(props, nextProps) {
	// 	// return !nextProps == null
	// }

	componentWillMount() {
		let {columns} = this.props;

		let {filter, filterCondition} = this.state;

		var exclude = ['OBJECTID', 'CREATEDAT', 'UPDATEDAT']

		if (filterCondition == null && filter == null) {
			filter = {};
			filterCondition = {};
			columns.map((obj) => {
				(exclude.indexOf(obj.columnName.toUpperCase()) == -1 || obj.show) && obj.show != false
					? filterCondition[obj.columnName] = {
						label: 'E',
						value: 'equalTo'
					}
					: '';
			});

			this.setState({filterCondition: filterCondition, filter: filter});
		}
	}
	render() {
		console.log('calling header');
		let {filter, filterCondition} = this.state;

		let {
			columns,
			stateSetter,
			getTableData,
			loadOptions,
			accessible,
			buttonCustomId
		} = this.props;

		let customButtonId = typeof buttonCustomId !== 'undefined'
			? buttonCustomId
			: ''

		console.log('header', this.props);

		var exclude = ['OBJECTID', 'CREATEDAT', 'UPDATEDAT']

		const isUndefined = (obj) => typeof obj === 'undefined'
			? true
			: false;

		const IS_NULL = (obj) => obj === null;

		const getThStyle = (column) => !isUndefined(column.headerStyle) && !IS_NULL(column.headerStyle) ? (
				column.headerStyle
			) : (
				{
					whiteSpace: "nowrap"
				}
			);

		const renderColumns = (obj) => (exclude.indexOf(obj.columnName.toUpperCase()) == -1 || obj.show) && obj.show != false
			? <th style={getThStyle(obj)} key={obj.columnName}>{isUndefined(obj.columnLabel)
						? obj.columnName.toUpperCase()
						: obj.columnLabel.toUpperCase()}</th>
			: '';

		const renderFilter = (obj) => (exclude.indexOf(obj.columnName.toUpperCase()) == -1 || obj.show) && obj.show != false
			? <td key={obj.columnName}>
					{filterType(obj)}
				</td>
			: '';

		const filterType = (obj) => {
			var menuItem = (obj) => {
				return (
					<DropdownButton componentClass={InputGroup.Button} id={obj.columnName} title={!isUndefined(filterCondition[obj.columnName]) && !isUndefined(filterCondition[obj.columnName].label) ? filterCondition[obj.columnName].label : ""}>
						<MenuItem key="1" onClick={() => setFilterCondition(obj.columnName, 'E', 'equalTo')}>Equal</MenuItem>
						<MenuItem key="2" onClick={() => setFilterCondition(obj.columnName, 'GT', 'greaterThan')}>Greater Than</MenuItem>
						<MenuItem key="3" onClick={() => setFilterCondition(obj.columnName, 'LT', 'lessThan')}>Less Than</MenuItem>
						<MenuItem key="4" onClick={() => setFilterCondition(obj.columnName, 'GT/E', 'greaterThanOrEqualTo')}>Greater Than Or Equal</MenuItem>
						<MenuItem key="5" onClick={() => setFilterCondition(obj.columnName, 'LT/E', 'lessThanOrEqualTo')}>Less Than Or Equal</MenuItem>
					</DropdownButton>
				);
			};

			switch (obj.type.toUpperCase()) {
				case 'STRING':
					if (!isUndefined(obj.customFilter) && !isUndefined(obj.customFilter.display)) {
						return obj.customFilter.display(
							(!IS_NULL(filter) ? filter[obj.columnName] : ""),
							(value) => setValue(obj.columnName, value)
						)
					} else {
						return (<FormControl id={obj.columnName} type="text" value={filter[obj.columnName]} onChange={(e) => setValue(obj.columnName, e.target.value)}/>);
					}
					break;
				case 'NUMBER':
					if (!isUndefined(obj.customFilter) && !isUndefined(obj.customFilter.display)) {
						return obj.customFilter.display(
							(!IS_NULL(filter) ? filter[obj.columnName] : ""),
							(value) => setValue(obj.columnName, value)
						)
					} else {
						return (
							<InputGroup>
								<FormControl id={obj.columnName} type="number" value={filter[obj.columnName]} onChange={(e) => setValue(obj.columnName, e.target.value)}/> {menuItem(obj)}
							</InputGroup>
						);
					}
					break;
				case 'DATE':
					return (
						<InputGroup>
							<FormControl id={obj.columnName} type="date" value={filter[obj.columnName]} onChange={(e) => setValue(obj.columnName, e.target.value)}/> {menuItem(obj)}
						</InputGroup>
					);
					break;
				case 'BOOLEAN':
					return (<Select id={obj.columnName} value={filter[obj.columnName]} onChange={(val) => setValue(obj.columnName, val)} options={[
						{
							label: 'True',
							value: true
						}, {
							label: 'False',
							value: false
						}
					]}/>);
					break;
				case 'POINTER':
					return (<Select.Async autoload={false} id={obj.columnName} value={filter[obj.columnName]} onChange={(val) => setValue(obj.columnName, val)} loadOptions={(input, cb) => loadOptions(input, cb, obj.targetClass, obj.displayColumn)}/>);
					break;
				case "CUSTOM":
					if (!isUndefined(obj.customFilter) && !isUndefined(obj.customFilter.display)) {
						return obj.customFilter.display(
							(!IS_NULL(filter) ? filter[obj.columnName] : ""),
							(value) => setValue(obj.columnName, value)
						)
					} else {
						return "";
					}
					break;
				default:
					return ''
			};
		};

		const setValue = (filterName, value) => {
			filter[filterName] = value;
			this.setState({
				filter: filter
			}, () => {
				stateSetter([
					{
						state: 'filter',
						value: [filter, filterCondition]
					}
				]);
			});
		};

		const setFilterCondition = (filterName, label, conditions) => {
			filterCondition[filterName].label = label;
			filterCondition[filterName].value = conditions;
			this.setState({
				filterCondition: filterCondition
			}, () => {
				stateSetter([
					{
						state: 'filter',
						value: [filter, filterCondition]
					}
				]);
			});
		};

		return (
			<thead>
				<tr>
					{isUndefined(columns)
						? <th>No Data Available</th>
						: columns.map(renderColumns)}
					<th>ACTIONS</th>
				</tr>
				<tr>
					{isUndefined(columns)
						? <td>No Data Available</td>
						: columns.map(renderFilter)}
					<td>
						<div style={{
							display: accessible('FILTER')
						}}>
							<Button id={customButtonId} className="btn-primary" onClick={() => getTableData()}>SEARCH</Button>
						</div>
					</td>
				</tr>
			</thead>
		)
	}
}

export default Header;



// WEBPACK FOOTER //
// ./components/zynappse-crud/Table/Header.js